define([
	'jquery',
	'./jquery.gm'
], function($, gm){
	"use strict";

	window.web = window.web || {};
	var web = window.web;

	web.googlemaps = web.googlemaps || {};
	web.googlemaps.activeMarker = null;

	// listeners on google markers
	web.googlemaps.loadMarkersListeners = {
		click: function(e, data, marker) {
			// clicking on inactive marker
			if (!marker.opened) {
				// inactivate previously activated marker
				web.googlemaps.inactiveMarkers();

				// set current marker active
				web.googlemaps.activeMarker = marker;
				marker.opened = true;

			}
		}
	};

	web.googlemaps.inactiveMarkers = function() {
		if (web.googlemaps.activeMarker && web.googlemaps.activeMarker.opened) {
			web.googlemaps.activeMarker.opened = false;
			web.googlemaps.activeMarker = null;
		}
	};

	/**
	 * googlemap base setup
	 */
	if (typeof($.googlemap) != 'undefined') {
    $.googlemap.setDefaults({
      mapOptions: {
        startingPosition: {
          lat: 49.82664426403112,
          lng: 15.29296875,
          zoom: 7
        },
        mapTypeControl: false,
        scaleControl: false,
        panControl: true,
        streetViewControl: false,
        zoomControl: true,
        scrollwheel: false,
        styles: [
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#46bcec"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "color": "#f2f2f2"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 45
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#444444"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }
        ]
      },
      bubbleContentFormatter: function (mData) {
        var str = '';
        str += '<h2>' + mData.title + '</h2>';
        if (mData.address != '' && mData.address != null) str += '<p>' + mData.address + '</p>';
        if (mData.url != '' && mData.url != null) str += '<p><a class="btn btn-primary btn-small" href="' + mData.url + '">Detail</a></p>';
        return str;
      },
      markerTypes: [
        // default marker, empty
        {},
        {
          icon: {
            url: '/img/google-map/marker.png',
            size: new google.maps.Size(51, 62),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(25, 62)
          },
          shape: {
            coords: [27, 0, 46, 9, 53, 27, 37, 61, 27, 80, 15, 61, 0, 28],
            type: 'poly'
          }
        }
      ]
    });
  }
});



// WEBPACK FOOTER //
// ./fe/web-cigarhouse/src/js/plugins/jquery.gm.conf.js